export default __webpack_public_path__ + "static/media/mindmovie pc.05caaf37.png";